export default __webpack_public_path__ + "static/portfolio-masonry-d7a01db9ab3b9118572b24cff130c64e.jpg";